// extracted by mini-css-extract-plugin
export default {"drawings":"drawings__TedVQ","empty":"empty__MZVnh","chartList":"chartList__prkA8","sectionLabel":"sectionLabel__cFkNU"};